import type { UserInputValues } from '@tectonics/prs/user-input-values';
import type { OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import { isDirectDebitSelected } from '@tectonics/prs/nigeria/validation/direct-debit-required-field';

export function nigerianOutgoingPaymentMapper(userInputValues: UserInputValues): Partial<OutgoingPayment> {
  const directDebitSelected = isDirectDebitSelected(readInput(userInputValues, 'selectedPaymentMethod'), readInput(userInputValues, 'selectedEWallet'));

  return {
    country: 'ng',
    phone_number: readInput(userInputValues, 'nigerianPhoneNumber'),
    bank_details: {
      bank_code: readInput(userInputValues, 'selectedBankCode'),
      account_number: getAccountNumber(userInputValues, directDebitSelected),
    },
    ...(directDebitSelected ? {
      address: readInput(userInputValues, 'nigerianAddress'),
      mandate_redirect_url: window.location.href,
      enrollment: { subscription: { frequency: 'onetime' } },
    } : {}),
  };
}

function getAccountNumber(userInputValues: UserInputValues, directDebitSelected: boolean): string {
  if (!(directDebitSelected || isUssdSelected(userInputValues))) {
    return '';
  }

  return readInput(userInputValues, 'nigerianAccountNumber');
}

function isUssdSelected(userInputValues: UserInputValues): boolean {
  return userInputValues['selectedPaymentMethod'] === 'ewallet' && userInputValues['selectedEWallet'] === 'ussd';
}

function readInput(userInputValues: UserInputValues, name: string): string {
  const value = userInputValues[name];
  return typeof value === 'string' ? value : '';
}
